import { render } from "./schoolStationApply.vue?vue&type=template&id=0831ea3e&scoped=true"
import script from "./schoolStationApply.vue?vue&type=script&lang=js"
export * from "./schoolStationApply.vue?vue&type=script&lang=js"

import "./schoolStationApply.vue?vue&type=style&index=0&id=0831ea3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0831ea3e"]])

export default __exports__